<div class="h-100 pb-2 mx-4 d-flex align-items-center">
  <div class="container-box d-flex flex-column ml-auto mr-auto">
    <div class="flex-grow-1 align-self-center pb-5 pt-11 w-75">
      <py-login-header [view]="view"></py-login-header>
    </div>

    <div class="d-flex flex-column">
      <div class="position-relative">
        <div class="loading" *ngIf="isLoading">
          <cx-spinner></cx-spinner>

          <div>
            <p>{{ 'login.loadingYourAccountData_hint' | cxTranslate }}</p>
            <p>{{ 'login.slow_hint' | cxTranslate }}</p>
          </div>
        </div>

        <div class="d-flex flex-column" [class.invisible]="isLoading">
          <div class="align-self-center w-75 mb-11">
            <py-login-form
              *ngIf="view === loginFormView.Login"
              (changeView)="changeView($event)"
              (loginSuccess)="setLoading($event)"
            ></py-login-form>

            <py-forgot-password
              *ngIf="view === loginFormView.ForgotPassword"
              (changeView)="changeView($event)"
            ></py-forgot-password>

            <py-forgot-username *ngIf="view === loginFormView.ForgotUsername" (changeView)="changeView($event)">
            </py-forgot-username>

            <button
              *ngIf="view !== loginFormView.Login"
              type="button"
              (click)="back()"
              aria-controls="reset-password"
              class="btn btn-ternary btn-block mt-2"
            >
              {{ 'password.forgotten.backToSignIn_action' | cxTranslate }}
            </button>
          </div>

          <div
            *ngIf="![loginFormView.EmailSentForgotPassword, loginFormView.EmailSentForgotUsername].includes(view)"
            class="container-box-footer align-self-end"
          >
            <div class="d-flex h-100 flex-column align-items-center justify-content-center">
              <span class="register-link-label">{{ 'password.forgotten.noAccountYet_text' | cxTranslate }}</span>

              <a [routerLink]="{ cxRoute: 'register' } | cxUrl" class="mt-2">
                <b>{{ 'password.forgotten.signUp_action' | cxTranslate }} <i nz-icon nzType="arrow-right" class="ml-1"></i></b>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
